import React, { useState } from 'react';
import MuseConnector from './MuseConnector.js';
import Filters from './Filters.js';
import Sound from './Sound.js';

import './brainSounds.css';
function BrainSounds(props) {
    const [filters, setFilters] = useState(
    { 
        'Highpass': 'None', 
        'Lowpass': 'None',
        'Vibrato': 'None', 
        'Distortion': 'None',
        'Phaser': 'None', 
        'Feedback delay': 'None',
        'Chorus': 'None',
    });
    
    return (
        <div className='connect-div'>
            <MuseConnector handleMuseConnected = {(m) => props.handleMuseConnected(m)} handleMuseDisconnected={() => props.handleMuseDisconnected()} color = {props.color}/>
            <Sound filters = {filters} muse = {props.muse} id = {props.id} />
            <Filters filters = {filters} handleChange = {(f) => setFilters(f)} />
        </div>
    )
}

export default BrainSounds;
